module.exports = __webpack_public_path__ + "static/media/anthony-martinez-briggs.95a5be9b.md";